import axios from 'axios';

export const authMixin = {
    methods: {
        checkToken: function(provider, from, to, next) {
            // This fixes "detail": "CSRF Failed: CSRF token missing or incorrect." issue on django 
            // https://vsupalov.com/avoid-csrf-errors-axios-django/
            axios.defaults.xsrfCookieName = 'csrftoken'
            axios.defaults.xsrfHeaderName = "X-CSRFTOKEN"

            // used to be 'vue-authenticate.vueauth_token' but thats just a name so now 'den_vueauth_token'
            // this token generated by django, after authing with slack
            axios.post(window.location.origin + '/api/check/', {"token": localStorage.getItem("den_vueauth_token")}).then((response) => {
                
                // if token check is correct, logged in, continue
                if (response.data.status == true ) {
                    next(true)
                }
                else { //recursive, but otherwise auth fails
                    next({ name: 'login' })
                }
            }).catch((error) => {
                console.error("checkToken: error", error)
            })
        },
    }
}

